import React from "react"
import { Accordion, AccordionDetails, AccordionSummary, DownIcon } from "@carrotfertility/carotene-core"
import { ContentfulMarkdown } from "#/services/contentful/contentful-markdown-renderer"
import type { AccordionNode } from "../renderer/types"
import { ContentList } from "./content-item"

export function AccordionContent({ content }: { content: AccordionNode }) {
  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<DownIcon fontSize="large" />}
        aria-controls={`content-accordion-details-${content.id}`}
        id={`content-accordion-${content.id}`}
      >
        <ContentfulMarkdown>{content.summaryClickableElement}</ContentfulMarkdown>
      </AccordionSummary>
      <AccordionDetails>
        <ContentList contents={content.content} />
      </AccordionDetails>
    </Accordion>
  )
}
